import React from "react";
import { useSite } from "@/context/SiteContext";
import { Reveal, Overline } from "@/components/Reveal";

const Process = () => {
  const { t } = useSite();
  const p = t.process;

  return (
    <section id="process" data-testid="process-section" className="relative bg-card py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>{p.overline}</Overline>
            <h2 className="mt-6 font-heading text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              {p.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 border-l border-border pl-8 sm:pl-14">
          {p.steps.map((step, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                data-testid={`process-step-${i}`}
                className="group relative pb-14 last:pb-0"
              >
                <span className="absolute -left-[41px] top-1 flex h-4 w-4 items-center justify-center bg-background sm:-left-[65px]">
                  <span className="h-2.5 w-2.5 bg-gold transition-transform duration-500 group-hover:scale-150" />
                </span>
                <div className="flex flex-col gap-3 sm:flex-row sm:items-baseline sm:gap-8">
                  <span className="font-heading text-4xl font-light leading-none text-gold sm:text-5xl">
                    0{i + 1}
                  </span>
                  <div>
                    <h3 className="font-heading text-2xl font-normal sm:text-3xl">{step.title}</h3>
                    <p className="mt-2 max-w-lg font-body text-sm font-light leading-relaxed text-muted-foreground">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
